import { render } from "./facial_liveness_check_verification.html?vue&type=template&id=05d929b0&external"
import script from "./facial_liveness_check_verification.js?vue&type=script&lang=js&external"
export * from "./facial_liveness_check_verification.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__